export const elementIsInputLike = (element: Element) => {
  if (element['classList'].contains('textarea')) return true;
  if (element['classList'].contains('input')) return true;
  if (element['classList'].contains('wysiwyg-content')) return true;
  if (element['tagName'] === 'INPUT') return true;
  if (element['tagName'] === 'TEXTAREA') return true;
  return false;
};
